import { Brand, CategoryTypes, ProductCategory } from "../../utils/enums.utils";
import { ProposalAttachmentsStatus, ProposalCompanies, ProposalItemStatus, ProposalPaymentTerms, ProposalPricingSummaryStatus, ProposalStatus, ProposalValidity, ProposalWarranty } from "./proposals-response.interface";

export interface CreateProposalsInterface {
  project_name: string;
  project_code: string | null;
  category: CategoryTypes;
  product_category: ProductCategory;
  company: ProposalCompanies;
  selected_date: string;
  customer_ref: string | null;
  quotation_number: string | null;
  payment_terms: ProposalPaymentTerms;
  quote_validity: ProposalValidity;
  warranty: ProposalWarranty;
  company_remarks: string | null;
  status: ProposalStatus;
  company_id: string;
  created_by_id: string | null;
  updated_by_id: string | null;
}

export interface UpdateProposalsInterface {
  id: string;
  project_name?: string;
  project_code?: string | null;
  category?: CategoryTypes;
  product_category?: ProductCategory;
  company?: ProposalCompanies;
  selected_date?: string;
  customer_ref?: string | null;
  quotation_number?: string | null;
  payment_terms?: ProposalPaymentTerms;
  quote_validity?: ProposalValidity;
  warranty?: ProposalWarranty;
  company_remarks?: string | null;
  status?: ProposalStatus;
  company_id?: string;
  updated_by_id: string | null;
}

export interface CreateProposalAttachmentsInterface {
  proposal_id: string;
  attachment_id: string;
  status: ProposalAttachmentsStatus;
}

export interface UpdateProposalAttachmentsInterface {
  proposal_id: string;
  attachment_id: string;
  status: ProposalAttachmentsStatus;
}

export interface CreateProposalItemsInterface {
  item_details: string | null;
  description: string | null;
  quantity: number | null;
  uom: string | null;
  buying_vat_inc: number | null;
  total_buying: number | null;
  shipping_fee: number | null;
  wsf: number | null;
  markup: number | null;
  sp: number | null;
  sp_each: number | null;
  misc: number | null;
  tpc_price: number | null;
  fsp: number | null;
  fsp_each: number | null;
  profit_each: number | null;
  total_profit: number | null;
  delivery: string | null;
  project: string | null;
  lof: string | null;
  aof: string | null;
  srf: string | null;
  lsf: string | null;
  brand: Brand;
  proposal_id: string;
  attachment_item_img: string | null;
  status: ProposalItemStatus;
}

export interface UpdateProposalItemsInterface {
  id: string;
  item_details?: string | null;
  description?: string | null;
  quantity?: number | null;
  uom?: string | null;
  buying_vat_inc?: number | null;
  total_buying?: number | null;
  shipping_fee?: number | null;
  wsf?: number | null;
  markup?: number | null;
  sp?: number | null;
  sp_each?: number | null;
  misc?: number | null;
  tpc_price?: number | null;
  fsp?: number | null;
  fsp_each?: number | null;
  profit_each?: number | null;
  total_profit?: number | null;
  delivery?: string | null;
  project?: string | null;
  lof?: string | null;
  aof?: string | null;
  srf?: string | null;
  lsf?: string | null;
  brand?: Brand;
  attachment_item_img?: string | null;
  status?: ProposalItemStatus;
}

export interface CreateProposalPricingSummaryInterface {
  subtotal: number;
  shipping_fee: number;
  markup: number;
  misc: number;
  approval_discount: number;
  discount_percent: number;
  discount_amount: number;
  total_ex_vat: number;
  total_inc_vat: number;
  total_profit: number;
  grand_total: number;
  lead_time: string | null;
  proposal_id: string;
  status: ProposalPricingSummaryStatus;
}

export interface UpdateProposalPricingSummaryInterface {
  id: string;
  subtotal?: number;
  shipping_fee?: number;
  markup?: number;
  misc?: number;
  approval_discount?: number;
  discount_percent?: number;
  discount_amount?: number;
  total_ex_vat?: number;
  total_inc_vat?: number;
  total_profit?: number;
  grand_total?: number;
  lead_time?: string | null;
  status?: ProposalPricingSummaryStatus;
}
